var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuotaSinistra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.485,
    height: 16.595,
    viewBox: "0 0 18.485 16.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_ruota_a_sinistra",
    "data-name": "icona ruota a sinistra",
    transform: "translate(-394.586 -79.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_ruota_a_sinistra-2",
    "data-name": "icona ruota a sinistra",
    transform: "translate(396 81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_456",
    "data-name": "Tracciato 456",
    d: "M25.5,6v4.8h4.8",
    transform: "translate(-25.5 -5.201)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_457",
    "data-name": "Tracciato 457",
    d: "M6.513,14.1a7.2,7.2,0,1,0,1.7-7.489L4.5,10.1",
    transform: "translate(-4.505 -4.503)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_1829",
    "data-name": "Rettangolo 1829",
    transform: "translate(396 80)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuotaSinistra);
export default __webpack_public_path__ + "static/media/ruota_sinistra.c5cc2b385da1d86ddc28c99e431354b9.svg";
export { ForwardRef as ReactComponent };